export class DrivetimeFeature {
  constructor(public rank: number, public feature: HTMLElement) {}
}

export class ImageSet {
  constructor(public id: number, public img: any) {}
}
